import { CommonModule } from "@angular/common";
import { Component, Input, OnInit } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { Policy } from "@shared/models/policy";
import { StatusConfig } from "@shared/models/status-config.model";
import { PolicyStatusService } from "@shared/services/policy-status.service";
import { AccordionModule } from "primeng/accordion";

@Component({
  selector: "app-contract-card",
  standalone: true,
  templateUrl: "./contract-card.component.html",
  imports: [CommonModule, TranslateModule, AccordionModule],
})
export class ContractCardComponent implements OnInit {
  @Input() contract!: Policy;
  contractStatusConfig!: Record<string, StatusConfig>;

  constructor(private readonly policyStatusService: PolicyStatusService) {}

  ngOnInit(): void {
    this.contractStatusConfig = this.policyStatusService.getStatusConfig();
  }
}
